import { addInterestedParty, updateNeedInterestedParties } from '../../slices/extraInfo';
import { AppDispatch } from '../../store';
import { Cover } from '../../types/cover';
import { InterestedPartyUI, Risk } from '../../types/policy';

const getInterestedPartiesByProvidedCovers = (
  risk: Risk | undefined,
  providedCovers: Cover[]
): Omit<InterestedPartyUI, 'id'>[] | [] => {
  if (!risk) return [];

  const { interestedParties } = risk;
  const interestedPartiesByProvidedCovers: Omit<InterestedPartyUI, 'id'>[] = [];

  if (interestedParties && interestedParties.length > 0) {
    if (providedCovers.length === 0) return [];

    const coverToPopulate = providedCovers[0];

    interestedParties.forEach(({ name }) =>
      interestedPartiesByProvidedCovers.push({
        cover: coverToPopulate,
        name,
      })
    );
  }

  return interestedPartiesByProvidedCovers;
};

const filterCovers = (neededCovers: Cover[], availableCovers: Cover[]) =>
  availableCovers.filter((c) => neededCovers.includes(c));
export const updateInterestedPartiesAction = ({
  buildingAndContentsRisk,
  portableItemsRisk,
  theftMoneyGlassRisk,
  covers,
  dispatch,
}: {
  covers: Cover[];
  buildingAndContentsRisk: Risk | undefined;
  portableItemsRisk: Risk | undefined;
  theftMoneyGlassRisk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  /**
   * @note since interested parties are combined from cover level into risk level
   * in the request payload for all Policy APIs, and don't have a way to be mapped
   * back to the original cover via the retrieve quote response, we need to pick the
   * first available cover in the response per risk to populate potential
   * interested parties into.
   *
   * I.e. Customer created interested parties for Money and Glass, and upon
   * retrieve quote - all interestedParties for TheftMoneyGlass risk get populated
   * into the Money Cover IPs */

  const buildingAndContentsParties = getInterestedPartiesByProvidedCovers(
    buildingAndContentsRisk,
    filterCovers([Cover.BuildingAndContents, Cover.BusinessInterruption], covers)
  );

  const portableItemsParties = getInterestedPartiesByProvidedCovers(
    portableItemsRisk,
    filterCovers([Cover.PortableItems], covers)
  );

  const theftMoneyGlassParties = getInterestedPartiesByProvidedCovers(
    theftMoneyGlassRisk,
    filterCovers([Cover.Theft, Cover.Money, Cover.Glass], covers)
  );

  const combinedInterestedParties = [
    ...buildingAndContentsParties,
    ...portableItemsParties,
    ...theftMoneyGlassParties,
  ];

  if (combinedInterestedParties.length > 0) {
    dispatch(updateNeedInterestedParties(true));
    combinedInterestedParties.forEach(({ name, cover }) =>
      dispatch(
        addInterestedParty({
          name,
          cover,
        })
      )
    );
  }
};
